<template>
  <div class="logInComponent">
    <div class="logInContainer">
      <div class="logInCard">
        <div class="logoContainer">
          <img alt="ACG logo" class="logo" src="@/assets/img/logoblack.svg" />
        </div>
        <validation-observer  v-slot="{ handleSubmit }" tag="div">
          <form @submit.prevent="handleSubmit(formSubmit)"  class="form form--login" >
            <h4 style="text-align: center">Request new password</h4>
            <p style="text-align: center">To request a new password, please enter your e-mail address.</p>
            <div class="inputContainer">
              <div>
                <ValidationProvider rules="required" v-slot="{ errors }"> 
                  <div class="form-row">
                    <input class="emailInput" placeholder="E-mail" name="E-mail" type="text" v-model="loginForm.email" />
                    <div class="form__error">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
                
              
              </div>
              <div class="error--s" style="font-size:12px; color: red; margin-bottom: 10px;" v-if="error.length > 0">{{error}}</div>
              <div class="error--s" style="font-size:12px; color: green; margin-bottom: 10px;" v-if="success.length > 0">{{success}}</div>
              <button type="submit" class="btn btn-green logInButton">request new password</button>
            </div>
                 <div class="login-back-link">
              <router-link class="text-link" :to="{name: 'LogIn'}">Login</router-link>
            </div>
          </form>
       
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend  } from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "{_field_} is required."
});

export default {  
  data(){
    return{
      loginForm:{
        email: null,
       
      },
      error: "",
      success: ""
    }
  },
  components:{
    ValidationProvider,
    ValidationObserver        
  },
  created(){
    
  },
  methods:{
    formSubmit(){
        let _this = this

        _this.post('forgottenpassword/sendmail',
          {
            email: _this.loginForm.email,
            password: _this.loginForm.psw
          },
          {},function () {
              _this.loginForm.email = "";
            _this.success ="We sent you an e-mail with the necessary informations about new password request."
            
          },function(error){
            //error
            //console.log('login error:', error.data)
            
            if (error.data.error == 'Not found!'){
              _this.error = 'Something went wrong :('
            }
          }
        )
    }
  }
}
</script>